import React from 'react';
import { Hero } from '../components/Hero';
import { LocalTrust } from '../components/LocalTrust';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
export function Home() {
  return <main data-id="element-1459">
      <Hero data-id="element-1460" />
      <LocalTrust data-id="element-1461" />
      <Services data-id="element-1462" />
      <HowItWorks data-id="element-1463" />
      <FAQ data-id="element-1464" />
      <Reviews data-id="element-1465" />
    </main>;
}